import * as PIXI from "pixi.js";
import { Point } from "../models";

export const potTotalTextTopPosition: PIXI.Point = new PIXI.Point(500, 1135); // top-left
export const potTotalTextDoubleBoardPosition: PIXI.Point = new PIXI.Point(500, 1085); // top-left
export const potTotalTextRightPosition: PIXI.Point = new PIXI.Point(488, 455); // top-left

export const TablePosition: Point = { x: 0, y: 588 }; 
export const TablePositionUnlimited: Point = { x: 960, y: 480 }; // center
export const TableShadowPosition: Point = { x: 270, y: 290 }; // top-left
export const MainPotPositions: Point[] = [
  { x: 540, y: 1356 }, // center
  { x: 678, y: 1356 }, // double-board second pot
  { x: 540, y: 1356 }, // if it's not double board
];
export const DoubleBoardMainPotPositions: Point[] = [
  { x: 430, y: 1460 },
  { x: 650, y: 1460 },
];
export const FpsPosition: Point = { x: 10, y: 140 };
export const TopLeftInfoPosition: Point = { x: 540, y: 200 };

export const SexyDealerPosition: Point = { x: 559, y: 133 };
// export const SexyDealerPositionUnlimited: Poit = { x: 960, y: 108 };

export const SeatsVisibility = {
  0: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 0 players - NOT POSSIBLE
  1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 1 player - NOT POSSIBLE
  2: [1, 0, 0, 1, 0, 0, 0, 0, 0, 0], // 2 players
  3: [1, 0, 0, 1, 0, 0, 1, 0, 0, 0], // 3 players
  4: [0, 1, 0, 1, 0, 0, 1, 0, 0, 1], // 4 players
  5: [0, 0, 1, 1, 0, 1, 0, 1, 1, 0], // 5 players
  6: [1, 1, 1, 0, 0, 1, 1, 1, 0, 0], // 6 players
  7: [0, 1, 1, 1, 0, 1, 0, 1, 1, 1], // 7 players
  8: [1, 1, 1, 1, 0, 1, 1, 1, 1, 0], // 8 players
  9: [1, 0, 1, 1, 1, 1, 1, 1, 1, 1], // 9 players
  10: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // 10 players
};

export const SeatsVisibilityWithDealer = {
  0: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 0 players - NOT POSSIBLE
  1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 1 player - NOT POSSIBLE
  2: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0], // 2 players
  3: [1, 0, 0, 1, 0, 1, 0, 0, 0, 0], // 3 players
  4: [0, 1, 0, 1, 0, 0, 1, 0, 0, 1], // 4 players
  5: [0, 0, 1, 1, 0, 1, 0, 1, 1, 0], // 5 players
  6: [1, 1, 1, 0, 0, 1, 1, 1, 0, 0], // 6 players
  7: [0, 1, 1, 1, 0, 1, 0, 1, 1, 1], // 7 players
  8: [1, 1, 1, 1, 0, 1, 1, 1, 1, 0], // 8 players
  9: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1], // 9 players
  10: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // 10 players
};

export const SeatPositions: Point[] = [
  { x: 454, y: 1777 }, // 0  local player / bottom center
  { x: 138, y: 1725 }, // 1
  { x: 36, y: 1658 }, // 2
  { x: 30, y: 1383 }, // 3
  { x: 33, y: 1267 }, // 4
  { x: 36, y: 1042 }, // 5
  { x: 30, y: 987 }, // 6
  { x: 42, y: 901 }, // 7
  { x: 50, y: 798 }, // 8
  { x: 96, y: 657 }, // 9
  { x: 155, y: 568 }, // 10
  { x: 454, y: 516 }, // 11 top center
  { x: 754, y: 568 }, // 12
  { x: 811, y: 657 }, // 13
  { x: 857, y: 798 }, // 14
  { x: 868, y: 901 }, // 15
  { x: 879, y: 987 }, // 16
  { x: 873, y: 1042 }, // 17
  { x: 876, y: 1267 }, // 18
  { x: 879, y: 1383 }, // 19
  { x: 871, y: 1658 }, // 20
  { x: 770, y: 1725 }, // 21
];

export const SeatLayoutIndices: Record<number, number[]> = {
  2: [0, 11], // 2 players
  3: [0, 8, 14], // 3 players
  4: [0, 5, 11, 17], // 4 players
  5: [0, 3, 8, 14, 19], // 5 players
  6: [0, 3, 8, 11, 14, 19], // 6 players
  7: [0, 3, 6, 10, 12, 16, 19], // 7 players
  8: [0, 3, 5, 9, 11, 13, 17, 19], // 8 players
  9: [0, 2, 4, 7, 10, 12, 15, 18, 20], // 9 players
  10: [0, 1, 3, 5, 9, 11, 13, 17, 19, 21], // 10 players
};

export const DealerButtonPositions: Point[] = [
  { x: 623, y: 1694 }, // 0  local player / bottom center
  { x: 330, y: 1670 }, // 1 ✅
  { x: 224, y: 1631 }, // 2
  { x: 90, y: 1604 }, // 3 ✅
  { x: 224, y: 1365 }, // 4
  { x: 213, y: 1182 }, // 5
  { x: 130, y: 1198 }, // 6
  { x: 237, y: 977 }, // 7
  { x: 155, y: 1013 }, // 8 ✅
  { x: 268, y: 821 }, // 9
  { x: 205, y: 775 }, // 10 ✅
  { x: 406, y: 677 }, // 11 top center
  { x: 895, y: 1198 }, // 12 ✅
  { x: 757, y: 821 }, // 13
  { x: 870, y: 1013 }, // 14 ✅
  { x: 788, y: 977 }, // 15
  { x: 820, y: 775 }, // 16 ✅
  { x: 812, y: 1182 }, // 17
  { x: 801, y: 1365 }, // 18
  { x: 935, y: 1604 }, // 19 ✅
  { x: 801, y: 1631 }, // 20
  { x: 723, y: 1662 }, // 21
];

export const PotPositions: Point[] = [
  { x: 460, y: 1644 }, // 0  local player / bottom center
  { x: 241, y: 1605 }, // 1
  { x: 197, y: 1595 }, // 2
  { x: 225, y: 1562 }, // 3 ✅
  { x: 213, y: 1422 }, // 4
  { x: 213, y: 1134 }, // 5
  { x: 226, y: 1151 }, // 6 ✅
  { x: 241, y: 918 }, // 7
  { x: 225, y: 966 }, // 8 ✅
  { x: 222, y: 882 }, // 9
  { x: 345, y: 735 }, // 10 ✅
  { x: 460, y: 718 }, // 11 top center
  { x: 694, y: 1151 }, // 12 ✅
  { x: 732, y: 882 }, // 13
  { x: 695, y: 966 }, // 14 ✅
  { x: 679, y: 918 }, // 15
  { x: 575, y: 735 }, // 16 ✅
  { x: 707, y: 1134 }, // 17
  { x: 715, y: 1422 }, // 18
  { x: 695, y: 1562 }, // 19 ✅
  { x: 732, y: 1575 }, // 20
  { x: 715, y: 1605 }, // 21
];

export const FigmaPotFrameSize: Point = { x: 161.493, y: 49.905 };

export const PlayerPositions: Point[] = [
  { x: 441, y: 1713 }, // 0  local player / bottom center
  { x: 125, y: 1664 }, // 1
  { x: 23, y: 1600 }, // 2
  { x: 17, y: 1334 }, // 3
  { x: 20, y: 1212 }, // 4
  { x: 25, y: 981 }, // 5
  { x: 20, y: 923 }, // 6
  { x: 28, y: 837 }, // 7
  { x: 50, y: 740 }, // 8
  { x: 84, y: 613 }, // 9
  { x: 142, y: 505 }, // 10
  { x: 441, y: 446 }, // 11 top center
  { x: 740, y: 507 }, // 12
  { x: 798, y: 613 }, // 13
  { x: 832, y: 740 }, // 14
  { x: 854, y: 837 }, // 15
  { x: 862, y: 923 }, // 16
  { x: 857, y: 981 }, // 17
  { x: 862, y: 1212 }, // 18
  { x: 865, y: 1334 }, // 19
  { x: 859, y: 1600 }, // 20
  { x: 757, y: 1664 }, // 21
];

export const DealerChipPositions: Point[] = [
  { x: 476, y: 263 },
  { x: 764, y: 419 },
  { x: 717, y: 548 },
  { x: 706, y: 1149 },
  { x: 775, y: 1284 }, // center
  { x: 607, y: 1453 },
  { x: 302, y: 1275 },
  { x: 373, y: 1149 },
  { x: 361, y: 548 },
  { x: 321, y: 419 },
];
export const DealerChipPositionsFor6Players: Point[] = [
  { x: 476, y: 263 },
  { x: 764, y: 419 },
  { x: 717, y: 548 },
  { x: 0, y: 0 },
  { x: 0, y: 0 }, // center
  { x: 607, y: 1453 },
  { x: 302, y: 1275 },
  { x: 373, y: 1149 },
  { x: 0, y: 0 },
  { x: 0, y: 0 },
];

export const ClubLogoLeftPosition: Point = { x: 735, y: 480 };
export const ClubLogoRightPosition: Point = { x: 1185, y: 480 };
export const BrandLogoPosition: Point = { x: 540, y: 1000 };

export const BlindsTextPosition: Point = { x: -10, y: -10 }; // center

export const TournamentTimersPosition: Point = { x: 1600, y: 0 }; // wrong values
export const TableNamTextPosition: Point = { x: 540, y: 804 };
export const TableDescriptionTextPosition: Point = { x: 540, y: 804 };

export const TableBlindsTextPosition: Point = { x: -10, y: -10 }; // wrong values

export const TripleDrawInfoPosition: Point = { x: 550, y: 805 };

export const TableTextRabbitHunting: Point = { x: 550, y: 580 };

/// *** OLD

export const SeatPositionsUnlimited: Point[] = [
  { x: 537, y: 143 + 12 },
  { x: 954, y: 143 + 12 },
  { x: 1371, y: 143 + 12 },
  { x: 1725, y: 331 + 12 },
  { x: 1725, y: 582 + 12 }, // center
  { x: 1371, y: 824 - 60 },
  { x: 954, y: 824 - 60 },
  { x: 537, y: 824 - 60 },
  { x: 196, y: 585 + 12 },
  { x: 196, y: 332 + 12 },
];
export const SeatPositionsFor6PlayersUnlimited: Point[] = [
  { x: 317, y: 193 },
  { x: 954, y: 144 },
  { x: 1607, y: 193 },
  { x: 0, y: 0 },
  { x: 0, y: 0 }, // center
  { x: 1607, y: 720 - 60 },
  { x: 954, y: 825 - 60 },
  { x: 317, y: 720 - 60 },
  { x: 0, y: 0 },
  { x: 0, y: 0 },
];

export const SeatPositionsAdvanced: Point[] = [
  { x: 541, y: 157 },
  { x: 958, y: 157 },
  { x: 1367, y: 157 },
  { x: 1621, y: 346 },
  { x: 1621, y: 598 }, // center
  { x: 1367, y: 838 },
  { x: 953, y: 838 },
  { x: 542, y: 838 },
  { x: 301, y: 598 },
  { x: 301, y: 346 },
];
export const SeatPositionsAdvancedFor6Players: Point[] = [
  { x: 419, y: 190 },
  { x: 958, y: 157 },
  { x: 1504, y: 190 },
  { x: 0, y: 0 },
  { x: 0, y: 0 }, // center
  { x: 1504, y: 764 },
  { x: 953, y: 838 },
  { x: 419, y: 764 },
  { x: 0, y: 0 },
  { x: 0, y: 0 },
];

export const PotPositionsUnlimited: Point[] = [
  { x: 667, y: 266 },
  { x: 1036, y: 300 },
  { x: 1242, y: 266 },
  { x: 1456, y: 376 },
  { x: 1456, y: 598 }, // center
  { x: 1245, y: 660 }, // { x: 1245, y: 660 - 62 },
  { x: 1039, y: 650 }, // { x: 1039, y: 660 - 62 },
  { x: 667, y: 660 }, // { x: 667, y: 660 - 62 },
  { x: 443, y: 617 },
  { x: 443, y: 376 },
];
export const PotPositionsFor6PlayersUnlimited: Point[] = [
  { x: 493, y: 306 },
  { x: 1036, y: 300 },
  { x: 1438, y: 306 },
  { x: 0, y: 0 },
  { x: 0, y: 0 }, // center
  { x: 1438, y: 600 - 62 },
  { x: 1039, y: 650 }, // { x: 1039, y: 660 - 62 },
  { x: 493, y: 600 - 62 },
  { x: 0, y: 0 },
  { x: 0, y: 0 },
];

export const DealerChipPositionsUnlimited: Point[] = [
  { x: 596, y: 265 },
  { x: 858, y: 293 },
  { x: 1314, y: 265 },
  { x: 1486, y: 378 },
  { x: 1486, y: 551 }, // center
  { x: 1313, y: 656 },
  { x: 888, y: 660 },
  { x: 598, y: 656 },
  { x: 427, y: 576 },
  { x: 433, y: 337 },
];
export const DealerChipPositionsFor6PlayersUnlimited: Point[] = [
  { x: 468, y: 347 },
  { x: 858, y: 293 },
  { x: 1462, y: 347 },
  { x: 0, y: 0 },
  { x: 0, y: 0 }, // center
  { x: 1462, y: 558 - 62 },
  { x: 888, y: 660 },
  { x: 468, y: 558 - 62 },
  { x: 0, y: 0 },
  { x: 0, y: 0 },
];

export const PlayerPositionsUnlimited: Point[] = [
  { x: 539, y: 129 },
  { x: 956, y: 129 },
  { x: 1369, y: 129 },
  { x: 1723, y: 317 },
  { x: 1723, y: 570 }, // center
  { x: 1369, y: 810 - 72 },
  { x: 956, y: 810 - 72 },
  { x: 539, y: 810 - 72 },
  { x: 199, y: 570 },
  { x: 199, y: 317 },
];
export const PlayerPositionsFor6PlayersUnlimited: Point[] = [
  { x: 320, y: 179 },
  { x: 956, y: 129 },
  { x: 1606, y: 179 },
  { x: 0, y: 0 },
  { x: 0, y: 0 }, // center
  { x: 1606, y: 705 - 72 },
  { x: 956, y: 810 - 72 },
  { x: 320, y: 705 - 72 },
  { x: 0, y: 0 },
  { x: 0, y: 0 },
];
